import { FormGroup } from "@angular/forms";
import { disabledIntegration } from "./nexsys-form-config.model";
import { ClassValuationIntegration } from "./product.model";
import {
	VisibilityContext
} from "../../../../../cv.invision-views.ux/src/lib/generic-form/form-field/service/visibility-context";

export const INTEGRATION_FORM_CONFIG = {
	integration : {
		enabled:{
			path: 'integration.enabled',
			DataType: 'Boolean',
			DisplayText: `Integration`,
			Name: 'enabled',
			customClass: 'product-form-switch',
			required:false,
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					disabledIntegration(formGroup);
					formGroup.get('integration')?.setValue(new ClassValuationIntegration());
					formGroup.get('integration.enabled')?.setValue($event.checked);
					formGroup.get('integration').updateValueAndValidity();
				},
			},
		},
		integrationId:{
			DataType: 'Selector',
			path: 'integration.integrationId',
			UIControl: 'Dropdown',
			DisplayText: 'Select an Integration',
			label: 'Select an Integration',
			Name: 'integrationId',
			customClass: 'product-form-dropdown mb-4',
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			isRequired: function(control, jsonModelService: VisibilityContext) {
				return jsonModelService.IsEmpty() && jsonModelService.FindValue('enabled');
			},
			Visible: function (control, jsonModelService: VisibilityContext) {
				const integrationEnabled = jsonModelService.FindValue('enabled');
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				//const classOrigin = jsonModelService.FindRootValues('origin')[0];

				return integrationEnabled || false;
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					formGroup.get('integration').updateValueAndValidity();
				},
			},
		},
		isDefaultProduct:{
			path: 'integration.isDefaultProduct',
			DataType: 'Boolean',
			DisplayText: `Default Product Configuration`,
			Name: 'isDefaultProduct',
			customClass: 'product-form-switch ms-5',
			required:false,
			defaultValue: false,
			Visible: function (control, jsonModelService: VisibilityContext) {
				const integrationEnabled = jsonModelService.FindValue('enabled');
				const optionSelected = jsonModelService.FindValue('integrationId');
				return (integrationEnabled && optionSelected) || false;
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {

					formGroup.get('integration.productId')?.setValue(null);
					formGroup.get('integration.productName')?.setValue(null);

					if ($event.checked) {
						formGroup.get('isOrganizationLevel')?.setValue(false);
						formGroup.get('integration.productId')?.setValue('unknown');
						formGroup.get('integration.productName')?.setValue(null);
					}
					formGroup.get('integration').updateValueAndValidity();
				},
			},
		},
		productId:{
			DataType: 'Selector',
			path: 'integration.productId',
			UIControl: 'Dropdown',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productId',
			customClass: 'product-form-dropdown',
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			isRequired: function(control, jsonModelService: VisibilityContext) {
				return jsonModelService.IsEmpty() && (jsonModelService.FindValue('isDefaultProduct') === false) && jsonModelService.FindValue('enabled');
			},
			Visible: function (control, jsonModelService: VisibilityContext) {
				const integrationEnabled = jsonModelService.FindValue('enabled');
				const optionSelected = jsonModelService.FindValue('integrationId');
				const isDefaultProduct = jsonModelService.FindValue('isDefaultProduct');
				return (integrationEnabled && optionSelected && !isDefaultProduct) || false;
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexOption = formConfigModel.options.findIndex(element => element.value === value);
						const option = formConfigModel.options[indexOption];
						formGroup.get('integration.productName')?.setValue(option?.label);
					} else {
						formGroup.get('integration.productId')?.setValue(null);
						formGroup.get('integration.productName')?.setValue(null);
					}
				},
			},
		},
		productName:{
			DataType: 'Selector',
			path: 'integration.productName',
			UIControl: 'Dropdown',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productName',
			options: [],
			required: false,
			hidden: true,
		},
		isFhaProduct:{
			path: 'integration.isFhaProduct',
			DataType: 'Boolean',
			DisplayText: `Is a FHA Product`,
			Name: 'isFhaProduct',
			customClass: 'product-form-switch ms-5',
			required: false,
			Visible: function (control, jsonModelService: VisibilityContext) {
				const isDefaultProduct = jsonModelService.FindValue('isDefaultProduct');
				const optionSelected = jsonModelService.FindValue('integrationId');
				return (!isDefaultProduct && optionSelected) || false;
			}
		},
		isOrderIncomeStatement:{
			path: 'integration.isOrderIncomeStatement',
			DataType: 'Boolean',
			DisplayText: `Is Order Income Statement`,
			Name: 'isOrderIncomeStatement',
			customClass: 'product-form-switch  ms-3',
			required: false,
			Visible: function (control, jsonModelService: VisibilityContext) {
				const isDefaultProduct = jsonModelService.FindValue('isDefaultProduct');
				const optionSelected = jsonModelService.FindValue('integrationId');
				return (!isDefaultProduct && optionSelected) || false;
			}
		},
		isOrderRentSchedule:{
			path: 'integration.isOrderRentSchedule',
			DataType: 'Boolean',
			DisplayText: `Is Order Rent Schedule`,
			Name: 'isOrderRentSchedule',
			customClass: 'product-form-switch  ms-3',
			required: false,
			Visible: function (control, jsonModelService: VisibilityContext) {
				const isDefaultProduct = jsonModelService.FindValue('isDefaultProduct');
				const optionSelected = jsonModelService.FindValue('integrationId');
				return (!isDefaultProduct && optionSelected) || false;
			}
		},
		defaultFhaNumber:{
			path: 'integration.defaultFhaNumber',
			DataType: 'String',
			DisplayText: `Default FHA Number`,
			Name: 'defaultFhaNumber',
			customClass: '',
			isRequired: function(control, jsonModelService: VisibilityContext) {
				return jsonModelService.IsEmpty() && jsonModelService.FindValue('isFhaProduct');
			},
			Visible: function (control, jsonModelService: VisibilityContext) {
				const isDefaultProduct = jsonModelService.FindValue('isDefaultProduct');
				const optionSelected = jsonModelService.FindValue('integrationId');
				const fhaEnabled = jsonModelService.FindValue('isFhaProduct');
				return (!isDefaultProduct && optionSelected && fhaEnabled) || false;
			}
		}
	}
};
